<div
  class="accordion-header"
  (click)="toggleGoalExpansion(goal)"
  [id]="'goal-' + goal.user_goal_type.title">
  <div class="accordion-header-content" [ngClass]="{'completed-task': goal.state === 'done'}">
    <div class="goal-title-row content">
      <div class="goal-icon-container">
        <img [src]="goal.icon" [ngClass]="{'goal-icon': windowService.isDesktopRes, 'advanced-icon': !windowService.isDesktopRes}" />
      </div>
      <tidy-text
        [header]="goal.user_goal_type.title"
        style="margin-right: 10px" />
    </div>
    <div class="completion-status-container">
      <tidy-text
        class="completion-status"
        [body]="'(' + goal.completedSteps + '/' + goal.user_goal_steps.length" /><span>&nbsp;</span>
        <tidy-text
          class="completion-status"
          [body]="'Completed)'" />
      </div>
    </div>

    <div class="accordion-icon-container">
      <!--<button
      mat-icon-button
      fill="clear"
      class="green-button"
      (click)="$event.stopPropagation(); openVideo.emit(goal)">
      <img src="assets/svg/circle-play.svg" alt="play" class="play-icon" />
    </button>-->
    <button mat-icon-button fill="clear" class="green-button">
      <img
        src="assets/svg/chevron-right.svg"
        class="chevron-icon"
        [style.transform]="goal.isOpened ? 'rotate(-90deg)' : 'rotate(90deg)'" />
    </button>
  </div>
</div>

@if (goal.isOpened) {
  <div class="accordion-content">
    @for (step of sortSteps(goal.user_goal_steps); track step) {
      <div class="accordion-task-wrapper">
        <div
          class="accordion-task-container"
          [ngClass]="{'completed-task': step.state === 'done'}">
          <div class="content" (click)="goToTaskDetails.emit(step)">
            <div style="display: flex; width: 100%">
              <div style="display: flex; align-items: center">
                <tidy-checkbox
                  [disabled]="true"
                  (click)="$event.stopPropagation()"
                  class="checkbox-container"
                  [items]="[{value: true, viewValue: ''}]"
                  [initValue]="step.state === 'done'" />
                <tidy-text
                  style="margin-left: 10px"
                  [header]="step.title" />
                @if (step?.tag) {
                  <div [class]="step?.tag?.class">
                    <tidy-text
                      [body]="'<strong>' + step?.tag?.text + '</strong>'" />
                    </div>
                  }
                </div>
              </div>
              @if (step.state !== 'done') {
                <div class="chevron-icon-container">
                  <button mat-icon-button fill="clear">
                    <img src="assets/svg/chevron-right.svg" class="chevron-icon" />
                  </button>
                </div>
              }
            </div>
            @if (step.state !== 'done') {
              <tidy-row
                style="margin-top: -0.5rem; margin-left: 38px"
                >
                <tidy-text [body]="step.description" />
              </tidy-row>
            }
          </div>
        </div>
      }
      @if (isUnchosenGoal) {
        <tidy-row
          [align]="'center'"
          style="margin-top: 1rem"
          >
          <tidy-text
            [clickableBody]="'Add to your goals'"
            (click)="updateGoal.emit([goal.id, true])" />
        </tidy-row>
      }
    </div>
  }
